import { logger } from './logger';

const isDevelopment = process.env.NODE_ENV !== 'production';

const hasGtag = () => typeof window !== 'undefined' && typeof window.gtag === 'function';

const debugLog = (eventName, params) => {
  if (isDevelopment) {
    logger.debug(`[analytics] ${eventName}`, params);
  }
};

/**
 * Track a Google Analytics event safely.
 * @param {string} eventName
 * @param {object} params
 */
export const trackEvent = (eventName, params = {}) => {
  if (!eventName) {
    return;
  }

  if (!hasGtag()) {
    debugLog(`${eventName} (skipped - gtag unavailable)`, params);
    return;
  }

  try {
    window.gtag('event', eventName, params);
  } catch (error) {
    logger.warn('Failed to dispatch analytics event:', eventName, error);
  }
};

/**
 * Track a screen view event.
 * @param {string} screenName
 * @param {object} params
 */
export const trackScreenView = (screenName, params = {}) => {
  const safeScreenName = screenName || 'logo';
  trackEvent('screen_view', {
    app_name: 'nwc-website',
    screen_name: safeScreenName,
    ...params
  });
};

/**
 * Track an exception (non-fatal) event.
 * @param {string} description
 * @param {boolean} fatal
 * @param {object} params
 */
export const trackException = (description, fatal = false, params = {}) => {
  trackEvent('exception', {
    description,
    fatal,
    ...params
  });
};

